import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { FluentProvider } from "@fluentui/react-components";
import { customTheme } from "./theme/theme";
import { Provider } from "react-redux";
import { store } from "./store";
// import { msalInstance } from "./lib/authConfig";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// msalInstance.initialize().then(() => {
  // msalInstance.handleRedirectPromise().then(() => {
    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <FluentProvider theme={customTheme}>
            <App />
          </FluentProvider>
        </Provider>
      </React.StrictMode>
    );
  // });
// });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
